// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.webViewLayout-module_iframe__FGaZg {
    width: var(--iframe-width);
    height: var(--iframe-height);
}`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/layout/webViewLayout.module.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B,4BAA4B;AAChC","sourcesContent":[".iframe {\n    width: var(--iframe-width);\n    height: var(--iframe-height);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iframe": `webViewLayout-module_iframe__FGaZg`
};
export default ___CSS_LOADER_EXPORT___;
